<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ve8KoC/tc-custom/9781446376669.jpg?1740287945363" alt="This image is the cover for the book Gilded Cake"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gilded Cake
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Faye Cahill has taken metallic cakes to an all new, gorgeous level . . . A most ‘brilliant’ addition for any cake designer’s library!” —Wendy Kromer-Schell, coauthor of <i>Martha Stewart’s Wedding Cakes</i></b></p><p> Make cakes that sparkle with this comprehensive guide to metallic cakes from leading wedding cake designer Faye Cahill. Faye begins by exploring all the different materials available to the modern cake decorator, from gold leaf to edible paint, food-grade sprays, edible glitters, lustre dusts, edible sequins and more, then shows you in step-by-step detail the techniques you need for success. Twelve stunning gilded cake projects follow, showing you how to put your newfound skills to use on creative cake designs, each with an accompanying smaller project that is perfect for beginners to tackle before attempting the larger cake. Create spectacular cakes that shimmer and shine with this unique must-have guide. </p><p> “<i>The Gilded Cake</i> is a very beautiful book . . . bakers would learn a lot from the intricate techniques author Faye Cahill teaches through descriptions and series of nicely executed and illustrated step-by-step photos.” —<i>Manhattan Book Review</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Faye Cahill
      </h2>
      
      <p class="authorDescription body article"><B>Faye Cahill</B> has been a professional cake decorator for more than 20 years. Her company, Faye Cahill Cake Design, is based in Sydney, Australia. Faye&#39;s design aesthetic pairs tailored, refined looks with fine detailing and stylized flowers. Her work has been featured in trade magazines such as <I>Cake Masters</I> and online trend-spotting blogs like CakeGeek, as well as in wedding blogs and publications, including Brides.com, Style Me Pretty and Modern Wedding. Faye has a passion for teaching her techniques in local and international workshops, as well as on Craftsy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      SewandSo is an imprint of F&W Media International, Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0314d4c4